module.exports = __webpack_public_path__ + "img/simjob.fb27a536.png";